var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adjust"},[(_vm.show)?_c('b-icon',{attrs:{"icon":"check-circle","variant":"info","font-scale":"1.25","aria-label":"Yes"}}):_c('span',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }